import React, { Component } from 'react';
import {
    Box, Typography, Stack, Switch, FormControlLabel, Chip, Paper,
    Table, TableHead, TableBody, TableRow, TableCell, TableContainer,
    CircularProgress, Button
} from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button as RsButton } from 'reactstrap';
import Header from '../components/Header';
import { connect } from 'react-redux';
import AuthHOC from './Auth';
import { withAlert } from 'react-alert';

class PrintServerConnectionView extends Component {
    constructor(props) {
        super(props);

        this.state = {
            logs: [],
            checkedLogs: [],
            modal: false,
            message: '',
            type: '',
            serverstatus: '',
            loading: true,
            toggling: false,
            ...props
        };

        this.retry = this.retry.bind(this);
        this.refresh = this.refresh.bind(this);
        this.getActionEntries = this.getActionEntries.bind(this);
        this.checkChange = this.checkChange.bind(this);
        this.toggle = this.toggle.bind(this);
        this.rowClicked = this.rowClicked.bind(this);
        this.remove = this.remove.bind(this);
    }

    componentDidMount() {
        this.getActionEntries();
    }

    toggle() {
        this.setState({ modal: !this.state.modal });
    }

    getActionEntries() {
        this.setState({ loading: true });
        fetch(window.location.protocol + '//' + window.location.host + '/api/printing/getstatus', {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' }
        })
        .then(res => res.json())
        .then(result => {
            this.setState({
                logs: result.Connections || [],
                serverstatus: result.Status,
                loading: false
            });
        })
        .catch(error => {
            console.error(error);
            this.setState({ loading: false });
        });
    }

    retry(stop) {
        this.setState({ toggling: true });
        fetch(window.location.protocol + '//' + window.location.host + '/api/printing/reset', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ Request: stop ? 'Stop' : 'Start' })
        })
        .then(res => res.json())
        .then(result => {
            this.props.alert.success(result.message);
            this.refresh();
        })
        .finally(() => this.setState({ toggling: false }));
    }

    remove() {
        this.props.alert.show('Ending selected connections...');
        fetch(window.location.protocol + '//' + window.location.host + '/api/printing/kill', {
            method: 'DELETE',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(this.state.checkedLogs)
        })
        .then(res => res.json())
        .then(() => {
            this.props.alert.success('Connections ended.');
            this.refresh();
        });
    }

    refresh() {
        this.setState({ checkedLogs: [], logs: [] });
        this.getActionEntries();
    }

    checkChange(log) {
        if (!this.state.checkedLogs.includes(log))
            this.setState(prev => ({ checkedLogs: [...prev.checkedLogs, log] }));
        else
            this.setState(prev => ({ checkedLogs: prev.checkedLogs.filter(j => j !== log) }));
    }

    rowClicked(filename) {
        const found = this.state.logs.find(e => e.Name === filename);
        if (!found) return;
        fetch(window.location.protocol + '//' + window.location.host + '/api/printing/x3printers?client=' + found.Name, {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' }
        })
        .then(res => res.json())
        .then(result => {
            this.setState({ type: 'Active Printers', message: result.printers, modal: true });
        });
    }

    render() {
        const { parsed } = this.props;
        const { logs, loading, serverstatus, checkedLogs, modal, message, type, toggling } = this.state;

        const isRunning = serverstatus === 'Running ...';

        const infoModal = message && message.length > 0 ? (
            <Modal isOpen={modal} toggle={this.toggle}>
                <ModalHeader toggle={this.toggle}>{type}</ModalHeader>
                <ModalBody>
                    {message.map((m, i) => <p key={i}>{m.printer}</p>)}
                </ModalBody>
                <ModalFooter>
                    <RsButton color="secondary" onClick={this.toggle}>Close</RsButton>
                </ModalFooter>
            </Modal>
        ) : <div />;

        return (
            <div className="App">
                <Header visible={!parsed.X3} />
                <div id="s-site-body" className="page-wrapper">
                    <div className="s-page">
                        <div className="s-page-header">
                            <Stack spacing={0.5} alignItems="flex-start" sx={{ mb: 3, textAlign: 'left' }}>
                                <Typography variant="h5" sx={{ fontWeight: 600 }}>
                                    Websocket Connections
                                </Typography>
                                <Typography variant="body1" color="text.secondary">
                                    Manage active WebSocket connections for print and scan agents
                                </Typography>
                            </Stack>
                        </div>

                        <Paper elevation={1} sx={{ borderTop: '4px solid #7443f4', p: 3 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 3 }}>
                                <FormControlLabel
                                    control={
                                        <Switch
                                            checked={isRunning}
                                            disabled={toggling}
                                            onChange={() => this.retry(isRunning)}
                                            sx={{
                                                '& .MuiSwitch-switchBase.Mui-checked': { color: '#7443f4' },
                                                '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': { backgroundColor: '#7443f4' },
                                            }}
                                        />
                                    }
                                    label={
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                            <Typography variant="body2" sx={{ fontWeight: 500 }}>
                                                {toggling ? 'Updating...' : isRunning ? 'Running' : 'Stopped'}
                                            </Typography>
                                            <Chip
                                                label={isRunning ? 'Active' : 'Inactive'}
                                                color={isRunning ? 'success' : 'error'}
                                                variant="outlined"
                                                size="small"
                                            />
                                        </Box>
                                    }
                                />
                                <Button
                                    variant="outlined"
                                    startIcon={<RefreshIcon />}
                                    onClick={this.refresh}
                                    sx={{ borderColor: '#7443f4', color: '#7443f4', '&:hover': { borderColor: '#5b2fd4', color: '#5b2fd4' } }}
                                >
                                    Refresh
                                </Button>
                            </Box>

                                <TableContainer component={Paper} elevation={0} sx={{ border: '1px solid #eee', borderRadius: '12px' }}>
                                <Table size="small">
                                    <TableHead sx={{ backgroundColor: '#f5f5f5' }}>
                                        <TableRow>
                                            <TableCell sx={{ fontWeight: 500, color: '#555' }}>Name</TableCell>
                                            <TableCell sx={{ fontWeight: 500, color: '#555' }}>Address</TableCell>
                                            <TableCell sx={{ fontWeight: 500, color: '#555' }}>Protocol</TableCell>
                                            <TableCell sx={{ fontWeight: 500, color: '#555' }}>State</TableCell>
                                            <TableCell sx={{ fontWeight: 500, color: '#555' }}>Date</TableCell>
                                            <TableCell />
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {loading ? (
                                            <TableRow>
                                                <TableCell colSpan={6} align="center" sx={{ py: 4 }}>
                                                    <CircularProgress size={24} />
                                                </TableCell>
                                            </TableRow>
                                        ) : logs.length === 0 ? (
                                            <TableRow>
                                                <TableCell colSpan={6} align="center" sx={{ py: 3, color: 'text.secondary' }}>
                                                    No active connections.
                                                </TableCell>
                                            </TableRow>
                                        ) : logs.map((log, i) => (
                                            <TableRow
                                                key={i}
                                                onClick={() => this.rowClicked(log.Name)}
                                                sx={{ cursor: 'pointer', '&:hover': { backgroundColor: '#f9f9f9' } }}
                                            >
                                                <TableCell>{log.Name}</TableCell>
                                                <TableCell sx={{ color: '#e67e22' }}>{log.RemoteAddress}:{log.RemotePort}</TableCell>
                                                <TableCell>{log.RemoteProtocol}</TableCell>
                                                <TableCell>{log.State === 1 ? 'open' : log.State}</TableCell>
                                                <TableCell>{log.Date ? new Date(log.Date).toLocaleTimeString('en-GB') + ' ' + new Date(log.Date).toLocaleDateString('en-GB') : ''}</TableCell>
                                                <TableCell align="right">
                                                    <input
                                                        type="checkbox"
                                                        checked={checkedLogs.includes(log)}
                                                        onChange={() => this.checkChange(log)}
                                                        onClick={e => e.stopPropagation()}
                                                    />
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                                </TableContainer>

                            <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end' }}>
                                <Button
                                    variant="contained"
                                    color="error"
                                    onClick={this.remove}
                                    disabled={checkedLogs.length === 0}
                                >
                                    End Connection
                                </Button>
                            </Box>
                        </Paper>
                    </div>
                </div>
                {infoModal}
            </div>
        );
    }
}

export default connect(state => state)(AuthHOC(withAlert()(PrintServerConnectionView), { name: 'print_server_connections' }));
